import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.local';
import { PlaylistsHttpResult } from '../models/playlist.model';
import { IPlaylistApi } from './interfaces/playlist-abstract.api';

@Injectable({
  providedIn: 'root',
})
export class ExternalPlaylistApi implements IPlaylistApi {
  constructor(private readonly http: HttpClient) { }

  getPlaylists(page: number, limit: number, userId: number): Observable<PlaylistsHttpResult> {
    const params = new HttpParams()
      .set('page', page)
      .set('limit', limit);
    const url = environment.api.externalUser.playlists.replace('{userId}', '' + userId);
    return this.http.get<any>(url, { params });
  }
}
